'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addAvailabilityMessage = addAvailabilityMessage;

var _addAvailabilityMessageTimeout = require('./addAvailabilityMessageTimeout');

var _addAvailabilityMessageTimeout2 = _interopRequireDefault(_addAvailabilityMessageTimeout);

var _publishAvailabilityMessage = require('../actions/publishAvailabilityMessage');

var _getAvailabilityMessageTimeouts = require('../selectors/getAvailabilityMessageTimeouts');

var _getAvailabilityMessageTimeouts2 = _interopRequireDefault(_getAvailabilityMessageTimeouts);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FIVE_SECONDS_IN_MS = 5000;

function addAvailabilityMessage(_ref) {
  var channel = _ref.channel,
      threadId = _ref.threadId;

  return function (dispatch, getState) {
    var timeouts = (0, _getAvailabilityMessageTimeouts2.default)(getState());

    if (!timeouts.get(channel)) {
      var timeout = setTimeout(function () {
        dispatch((0, _publishAvailabilityMessage.publishAvailabilityMessage)({ channel: channel, threadId: threadId }));
      }, FIVE_SECONDS_IN_MS);

      dispatch((0, _addAvailabilityMessageTimeout2.default)(channel, timeout));
    }
  };
}